module.exports = __webpack_public_path__ + "static/media/features-richmedia-color.9917146b.png";